import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface RadioCardOption {
  title: string;
  subtitle: string;
  price?: string | number;
  badge?: string;
}

@Component({
  selector: 'black-ui-radio-card',
  templateUrl: './ui-radio-card.component.html',
  styleUrl: './ui-radio-card.component.scss',
  standalone: false,
  host: {
    ngSkipHydration: 'true',
  },
})
export class UiRadioCardComponent {
  @Input()
  options: RadioCardOption[] = [];

  @Input()
  selectedIndex = 1;
  @Output()
  selectedIndexChange = new EventEmitter<number>();

  updateSelectedIndex(index: number) {
    this.selectedIndex = index;
    this.selectedIndexChange.emit(this.selectedIndex);
  }
}
